import _isEqual from "fast-deep-equal/es6";

export const isEqual = _isEqual as <T>(
  actual: unknown,
  expected: T,
) => actual is T;
